import React from 'react'
import { Dropdown, Label, Icon } from 'semantic-ui-react'
const data = ["function", "cell"];

const composeOptions = (optionlist) => {
  let generatedOptions = []
  for (var i = 0; i < optionlist.length; i++) {
    generatedOptions.push({ key: i.toString(), text: optionlist[i], value: optionlist[i] })
  }
  return generatedOptions
};

class Filters extends React.Component {
  constructor(props) {
    super(props);
    this.data = data;
    this.state = {
      options: {
        function: null,
        cell: null
      },
      function: "",
      cell: ""
    };
    this.response = null;
    this.handleChange = this.handleChange.bind(this);
    this.makeOptions = this.makeOptions.bind(this);
  }

  handleChange = (e, { name, value }) => {
    // must update selected state beforehand to pass the "" check
    this.setState({ [name]: value }, () => {
      this.makeOptions(name, value, false)
      console.log('query', (this.state.function ? this.response.function_to_code[this.state.function] : 0),
        (this.state.cell ? this.response.cell_to_code[this.state.cell] : 0))
      this.props.queryRows(
        (this.state.function ? this.response.function_to_code[this.state.function] : 0),
        (this.state.cell ? this.response.cell_to_code[this.state.cell] : 0),
        (this.props.focus ? this.props.focus.code.toString() : null)
      )
    })
  }

  focusChange = () => {
    this.props.setFocus(this.props.focus)
    this.props.queryRows(
      (this.state.function ? this.response.function_to_code[this.state.function] : 0),
      (this.state.cell ? this.response.cell_to_code[this.state.cell] : 0),
      (this.props.focus ? this.props.focus.code.toString() : null)
    )
  }

  makeOptions = (name, value, prevnull) => {

    if (name === 'function') {
      // if the interaction was from the function dropdown
      if (value === "") {
        // If the user cleared the dropdown
        if (this.state.cell === "") {
          // if the cell dropdown does not currently have a selection,
          // We should have access to all options for both dropdowns now
          this.makeOptions(null, null, false)
        } else {
          // if the cell dropdown *does* currently have a selection,
          // We should have access to only the functions pertaining to that cell
          this.makeOptions("cell", this.state.cell, true)
        }
      } else {
        // If the user switched or newly selected a choice in the dropdown
        // lookup the function code
        let function_code = this.response.function_to_code[value]
        let cell_list = []
        // Use mapping to find cell codes, then push their names to a list
        for (var i = 0; i < this.response.fc_mapping[function_code].length; i++) {
          cell_list.push(this.response.code_to_cell[this.response.fc_mapping[function_code][i]])
        }
        if (prevnull) {
          // If we were directed here from a clear event of the cell dropdown
          // We should have access to all options in the function dropdown
          this.setState(prevState => ({
            ...prevState,
            options: {
              function: composeOptions(Object.keys(this.response.function_to_code).sort()),
              cell: composeOptions(cell_list.sort())
            }
          }))
        } else {
          // Otherwise, we should only have access to options limited by the cell dropdown
          this.setState(prevState => ({
            ...prevState,
            options: {
              ...prevState.options,
              cell: composeOptions(cell_list.sort())
            }
          }))
        }

      }

    } else if (name === 'cell') {
      // Do the same if the interaction was from the cell dropdown
      if (value === "") {
        if (this.state.function === "") {
          this.makeOptions(null, null, false)
        } else {
          this.makeOptions("function", this.state.function, true)
        }
      } else {

        let cell_code = this.response.cell_to_code[value]
        let function_list = []
        for (i = 0; i < this.response.cf_mapping[cell_code].length; i++) {
          function_list.push(this.response.code_to_function[this.response.cf_mapping[cell_code][i]])
        }
        if (prevnull) {
          this.setState(prevState => ({
            ...prevState,
            options: {
              function: composeOptions(function_list.sort()),
              cell: composeOptions(Object.keys(this.response.cell_to_code).sort())
            }
          }))
        } else {
          this.setState(prevState => ({
            ...prevState,
            options: {
              ...prevState.options,
              function: composeOptions(function_list.sort())
            }
          }))
        }
      }

    } else {
      // We reach a state where both dropdowns do not have a selection
      this.setState({
        options: {
          function: composeOptions(Object.keys(this.response.function_to_code).sort()),
          cell: composeOptions(Object.keys(this.response.cell_to_code).sort())
        }
      })

    }
  }

  async componentDidMount() {
    let res = await fetch("https://synbioapi.online/get_filters")
    this.response = await res.json()
    this.makeOptions(null, null, false)
    this.props.queryRows(0, 0, null) // show everything initially
  }

  render() {
    console.log(this.props.lastFocus, this.props.focus)
    if (this.props.lastFocus && this.props.focus) {
      if (!(this.props.lastFocus.text === this.props.focus.text)) {
        this.focusChange()
      }
    } else if (!this.props.lastFocus && this.props.focus) {
      this.focusChange()
    } else if (this.props.lastFocus && !this.props.focus) {
      this.focusChange()
    } //else do nothing

    return (
      <div style={{ height: "100%", display: "flex", width: "100%" }}>
        <div style={{ paddingRight: "1rem" }}>
          <Dropdown clearable selection search
            selectOnBlur={false}
            selectOnNavigation={false}
            name="function"
            options={this.state.options.function}
            onChange={this.handleChange}
            placeholder="Any Function" />
        </div>
        <div style={{ paddingRight: "1rem" }}>
          <Dropdown clearable selection search
            selectOnBlur={false}
            selectOnNavigation={false}
            name="cell"
            options={this.state.options.cell}
            onChange={this.handleChange}
            placeholder="Any Cell" />
        </div>
        <div style={{ paddingRight: "1rem" }}>
          <Label size='large'>
            {this.props.focus ? this.props.focus.text : "No focused entity"}
            {this.props.focus ? <Icon name='delete' size='big' onClick={this.props.removeFocus} />
              : null}
          </Label>
        </div>
        <div style={{ flexGrow: 1 }}></div>
        {/*<Search/>*/}
      </div>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/filters.jsx